import { Box, Fade, Popper } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

import { DateInput } from '@components/DateInput';
import Icon from '@components/Icon/Icon';
import {
  DropdownStyle,
  Selector,
} from '@components/RoundedDropdown/RoundedDropdown.style';

const DatePicker: React.FC<{
  label?: string;
  value?: Date;
  onChange?: (value: Date | null) => void;
}> = ({ value = new Date(), onChange, label = '' }) => {
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const calenderRef = useRef<HTMLInputElement>(null);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLInputElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
    setAnchorEl(event.currentTarget);
    setDatePickerOpen((previousOpen) => !previousOpen);
  };

  const handleDateChange = (value: Date | Date[] | null): void => {
    if (value instanceof Date || value === null) {
      onChange?.(value);
      setDatePickerOpen(false);
    }
  };

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (
        anchorEl &&
        !anchorEl.contains(event.target as Node) &&
        calenderRef.current &&
        !calenderRef.current.contains(event.target as Node)
      ) {
        setDatePickerOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClick, false);
    return () => {
      document.removeEventListener('mousedown', handleClick, false);
    };
  }, [anchorEl]);

  const canBeOpen = datePickerOpen && Boolean(anchorEl);
  const id = canBeOpen ? 'popper' : undefined;

  return (
    <DropdownStyle
      className={datePickerOpen ? 'open' : ''}
      style={{ position: 'relative' }}
    >
      <Selector
        onClick={handleClick}
        style={{ height: 'auto', minHeight: '34px' }}
      >
        {label}
        <Icon
          color="primary.contrastText"
          name="chevron-down"
          rotation={datePickerOpen ? 180 : 0}
        />
      </Selector>
      <Popper
        id={id}
        open={datePickerOpen}
        anchorEl={anchorEl}
        transition
        sx={{ zIndex: 10 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={50}>
            <Box ref={calenderRef}>
              <DateInput
                onChange={(date) => {
                  if (date instanceof Date) {
                    handleDateChange(date);
                  }
                }}
                value={value}
              />
            </Box>
          </Fade>
        )}
      </Popper>
    </DropdownStyle>
  );
};

export default DatePicker;
